import { Box, Button, Input, Text } from "@saleor/macaw-ui-next";
import { useIntl } from "react-intl";

import { Interval } from "./hours";
import { openingHoursMessages } from "./messages";

interface IntervalsEditorProps {
  value: Interval[];
  onChange: (value: Interval[]) => void;
  disabled?: boolean;
  testId?: string;
}

// A day's opening periods: none means closed; add as many as needed
// (e.g. morning and afternoon with a lunch break).
export const IntervalsEditor = ({ value, onChange, disabled, testId }: IntervalsEditorProps) => {
  const intl = useIntl();
  const update = (index: number, patch: Partial<Interval>) =>
    onChange(value.map((interval, i) => (i === index ? { ...interval, ...patch } : interval)));

  return (
    <Box display="flex" flexDirection="column" gap={2} data-test-id={testId}>
      {value.length === 0 && (
        <Text size={2} color="default2">
          {intl.formatMessage(openingHoursMessages.closed)}
        </Text>
      )}
      {value.map((interval, index) => (
        <Box key={index} display="flex" alignItems="center" gap={2} style={{ flexWrap: "wrap" }}>
          <Input
            type="time"
            size="small"
            aria-label={intl.formatMessage(openingHoursMessages.from)}
            value={interval.open}
            disabled={disabled}
            onChange={event => update(index, { open: event.target.value })}
            style={{ width: 130 }}
          />
          <Text>–</Text>
          <Input
            type="time"
            size="small"
            aria-label={intl.formatMessage(openingHoursMessages.to)}
            value={interval.close}
            disabled={disabled}
            onChange={event => update(index, { close: event.target.value })}
            style={{ width: 130 }}
          />
          <Button
            variant="tertiary"
            size="small"
            disabled={disabled}
            onClick={() => onChange(value.filter((_, i) => i !== index))}
          >
            {intl.formatMessage(openingHoursMessages.remove)}
          </Button>
        </Box>
      ))}
      <Box>
        <Button
          variant="secondary"
          size="small"
          disabled={disabled}
          onClick={() => onChange([...value, { open: "09:00", close: "13:00" }])}
        >
          {intl.formatMessage(openingHoursMessages.addPeriod)}
        </Button>
      </Box>
    </Box>
  );
};
